export type DramaComment = {
  id: string;
  dramaId: string;
  user: string;
  avatar: string;
  time: string;
  content: string;
  likes: number;
};

export const comments: DramaComment[] = [
  { id: 'c1', dramaId: 'd001', user: '追剧小分队', avatar: '追', time: '2 小时前', content: '前几集的节奏太稳了，权谋线和感情线都拿捏得刚好，坐等后续更新！', likes: 128 },
  { id: 'c2', dramaId: 'd001', user: '夜猫子看剧', avatar: '夜', time: '5 小时前', content: '服化道很用心，配乐一响起就有代入感，属于越看越上头的那种。', likes: 96 },
  { id: 'c3', dramaId: 'd001', user: '橘子汽水', avatar: '橘', time: '1 天前', content: '主角演技在线，几场对手戏真的绝了，希望后面别烂尾。', likes: 74 },
  { id: 'c4', dramaId: 'd001', user: '剧评人老周', avatar: '周', time: '1 天前', content: '这一部把历史感和悬疑结合得不错，尊重观众智商的剧本值得一看。', likes: 201 },
  { id: 'c5', dramaId: 'd001', user: '周末不加班', avatar: '周', time: '2 天前', content: '一口气刷了八集，完全停不下来，更新频率能不能再快一点。', likes: 45 },
  { id: 'c6', dramaId: 'd001', user: '甜剧爱好者', avatar: '甜', time: '3 天前', content: '男女主的化学反应很自然，CP 感满满，支持支持！', likes: 63 },
  { id: 'c7', dramaId: 'd001', user: '电影课代表', avatar: '影', time: '4 天前', content: '镜头语言很讲究，几个空镜的留白处理特别有味道。', likes: 88 },
  { id: 'c8', dramaId: 'd001', user: '路人甲', avatar: '路', time: '5 天前', content: '本来是随便点开看看，结果一路追到最新一集，已加入必追片单。', likes: 32 },
];